<top-banner variant="title" [title]="routeParams"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row animated fadeIn">

          <!-- side menu -->
          <div class="col-md-2 cardtabs-wrapper">
            <nav class="nav cardtabs flex-column">
              <div class="back-and-menu-link">
                <a [routerLink]="['/', routeRole, 'training']" class="nav-link back-link">all courses</a>
              </div>
            </nav>
          </div>

          <!-- main area -->
          <div class="col-md-10">

            <div class="card-body mb-2">
              <form [formGroup]="trainingForm">
                <div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <div>
                        <label>Type<span class="required-star"> *</span></label>
                        <p-dropdown class="form-control"
                          formControlName="courseType"
                          [options]="optionsType"
                          optionLabel="label"
                          placeholder="Select type..."
                          [style]="{ width: '100%' }" filter="true">
                        </p-dropdown>
                      </div>
                    </div>
                  </div>

                  <div class="row" *ngIf="!isSiteOwner">
                    <div class="form-group col-md-6">
                      <div>
                        <label>Site Owner<span class="required-star"> *</span></label>
                        <p-dropdown class="form-control"
                          formControlName="siteOwnerSkylarkId"
                          [options]="siteOwners"
                          optionLabel="label"
                          placeholder="Select site owner..."
                          [style]="{ width: '100%' }"
                          filter="true">
                        </p-dropdown>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Name<span class="required-star"> *</span></label>
                      <input type="text" class="form-control" formControlName="name" placeholder="Name" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Description<span class="required-star"> *</span></label>
                      <input type="text" class="form-control" formControlName="description" placeholder="Description" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Valid for (months) <span class="required-star"> *</span></label>
                      <input type="number" class="form-control" formControlName="validForMonths" placeholder="Valid for (months)" />
                    </div>
                  </div>

                  <div class="row" *ngIf="!isEditExistingCourse">
                    <div class="form-group col-md-6 d-flex justify-content-end">
                      <button type="button" [disabled]="!trainingForm.valid || isSaving" class="btn btn-success btn-round" (click)="submitMainSectionForm()">Save</button>
                    </div>
                  </div>
                  <div class="row" *ngIf="isEditExistingCourse">
                    <div class="form-group col-md-6 d-flex justify-content-end">
                      <button type="button" [disabled]="!trainingForm.valid || isSaving" class="btn btn-success btn-round" (click)="updateMainSection()">Save</button>
                    </div>
                  </div>
                </div>
              </form>

              <div *ngIf="mainSectionIsSaved">
                <div class="row">
                  <div class="col-md-12">
                    <div class="edit-training_border-spacer"></div>
                    <p class="edit-training_text">Inductions/trainings can have multiple sections. Each one must be completed in order by the worker.</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="d-flex justify-content-center edit-training_btn">
                      <button [disabled]="isReorderingMode" type="button" class="btn btn-primary btn-round" (click)="addVideoSection()">
                        <span class="edit-training_btn_group"><i class="fa fa-video"></i></span>Add Video Section
                      </button>
                      <button [disabled]="isReorderingMode" type="button" class="btn btn-primary btn-round" (click)="addPDFSection()">
                        <span class="edit-training_btn_group"><i class="fa fa-file-pdf"></i> </span>Add Document Section
                      </button>
                      <button [disabled]="isReorderingMode" type="button" class="btn btn-primary btn-round" (click)="addQuestionSection()">
                        <span class="edit-training_btn_group"><i class="fa fa-tasks"></i></span> Add Question Section
                      </button>
                      <button *ngIf="!isReorderingMode" type="button" class="btn btn-secondary btn-round" (click)="reorderSections()">
                        <span class="edit-training_btn_group"><i class="fas fa-sort-numeric-down"></i></span> Re-order sections
                      </button>
                      <button *ngIf="isReorderingMode" type="button" class="btn btn-success btn-round" (click)="saveOrder()">
                        <span class="edit-training_btn_group"><i class="fas fa-sort-numeric-down"></i></span> Save new order
                      </button>
                    </div>
                  </div>
                </div>

                <div *ngIf="loading" style="width: 50%; margin: 0 auto; display: flex; justify-content: center;">
                  <p-progressSpinner></p-progressSpinner>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <ng-container *ngFor="let section of sections; let i = index">
                      <div class="edit-training_section-bar">
                        <div class="d-flex justify-content-center align-items-center">
                          <div *ngIf="!isReorderingMode" class="col-md-2">Section {{ i + 1 }}</div>
                          <div *ngIf="isReorderingMode" class="col-md-2">
                            <p-dropdown
                              [(ngModel)]="sectionOrder[i].order"
                              [options]="orderOptions"
                              (onChange)="onDropdownChange(i)"
                            ></p-dropdown>
                          </div>

                          <div class="col-md-4"> {{section.sectionName}} </div>

                          <div class="col-md-5 d-flex justify-content-end">
                            <a *ngIf="section.sectionType === TrainingSectionType.Question"
                            [routerLink]="['/', routeRole, 'training', trainingId, 'edit', 'section', section.courseSectionId, 'questions']">
                              {{section.questions.length}} {{'question' | plural: section.questions.length}}
                            </a>

                            <div class="edit-training_section_fileName" *ngIf="section.sectionType === TrainingSectionType.Video">
                              <span> {{section.videoUri}}</span>
                            </div>

                            <div class="edit-training_section_fileName" *ngIf="section.sectionType === TrainingSectionType.Pdf">
                              <span> {{section.documentUrl}}</span>
                            </div>

                          </div>

                          <div class="col-md-1 d-flex justify-content-end">
                            <button *ngIf="!isReorderingMode" type="button" class="close" (click)="deleteSection(section.courseSectionId)"><span class="pi pi-times"></span></button>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>

                <br>
                <br>
                <div class="row">
                  <div class="col-md-12 d-flex justify-content-end">
                    <button *ngIf="isReorderingMode" type="button" class="btn btn-success btn-round" (click)="saveOrder()">
                      <span class="edit-training_btn_group"><i class="fas fa-sort-numeric-down"></i></span> Save new order
                    </button>
                    <button [disabled]="isReorderingMode" type="button" class="btn btn-success btn-round" (click)="finishEditing()">Finish</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
